<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8">
          <div class="card rounded-5 p-lg-3 border">
            <div class="card-body form-style">
              <div class="col-md-12">
                <div class="row mb-4">
                  <div class="col-lg-6 mb-4">
                    <label for>{{$lang.messages.name}}</label>
                    <span style="color:#ff0000">*</span>
                    <input
                      name="name"
                      v-model="store.name"
                      v-validate="'required|max:300'"
                      maxlength="300"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('name') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.name"
                    />
                    <i v-show="errors.has('name')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('name')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_name}}</span>
                  </div>

                  <div class="col-lg-6 mb-4">
                    <label for>{{$lang.messages.address}}</label>
                    <span style="color:#ff0000">*</span>
                    <textarea
                      v-bind:placeholder="$lang.messages.address"
                      type="text"
                      name="address"
                      v-model="store.address"
                      v-validate="'required'"
                      class="form-control"
                      rows="2"
                      style="height: auto"
                      :class="{'input': true, 'is-danger': errors.has('address') }"
                    ></textarea>
                    <i v-show="errors.has('address')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('address')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_address}}</span>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-lg-6 mb-4">
                    <label for>{{$lang.messages.mobile_number}}</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" >{{country_code}}</label>
                      </div>
                      <input
                        name="mobile"
                        v-model="store.mobile_number"
                        class="input form-control"
                        v-validate="'numeric|min: 7'"
                        :class="{'input': true, 'is-danger': errors.has('mobile') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.mobile_number"
                      />
                    </div>
                    <i v-show="errors.has('mobile')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('mobile')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_10_digits_mobile_number}}</span>
                  </div>

                  <div class="col-lg-6 mb-4">
                    <label for>{{$lang.messages.phone_number}}</label>
                    <input
                      name="phone"
                      v-model="store.phone_number"
                      class="input form-control"
                      v-validate="'numeric|min: 7'"
                      :class="{'input': true, 'is-danger': errors.has('phone_number') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.phone_number"
                    />
                    <i v-show="errors.has('phone_number')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('phone_number')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_10_digits_phone_number}}</span>
                  </div>
                </div>

                <div class="col-md-12 px-0">
                  <div class="row mb-4">
                    <div class="col-lg-6 mb-4">
                      <label>{{$lang.messages.email}}</label>
                      <input
                        name="email"
                        v-model="store.email"
                        v-validate="'email'"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('email') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.email"
                      />
                      <i v-show="errors.has('email')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('email')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_email}}</span>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label>{{$lang.messages.province}}</label>
                      <span style="color:#ff0000">*</span>
                      <div class="text-right custom-select-dd">
                        <select
                          v-model="store.state_id"
                          name="state_id"
                          class="form-control"
                          v-validate="'required'"
                          :class="{'input': true, 'is-danger': errors.has('state_id') }"
                          @change="getDistrictList(store.state_id, true)"
                        >
                          <option value>{{$lang.messages.select_province}}</option>
                          <option
                            v-for="state in stateList"
                            :key="state.id"
                            :value="state.id"
                          >{{state.name}}</option>
                        </select>
                        <i v-show="errors.has('state_id')" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('state_id')"
                          class="help is-danger"
                        >{{$lang.messages.select_province}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 px-0">
                  <div class="row mb-4">
                    <div class="col-lg-6 mb-4">
                      <label>{{$lang.messages.city}}</label>
                      <span style="color:#ff0000">*</span>
                      <div class="text-right custom-select-dd">
                        <select
                          v-model="store.district_id"
                          name="district_id"
                          class="form-control"
                          v-validate="'required'"
                          :class="{'input': true, 'is-danger': errors.has('district_id') }"
                          @change="getCityList(store.district_id, true)"
                        >
                          <option value>{{$lang.messages.select_city}}</option>
                          <option
                            v-for="district in districtList"
                            :key="district.id"
                            :value="district.id"
                          >{{district.name}}</option>
                        </select>
                        <i v-show="errors.has('district_id')" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('district_id')"
                          class="help is-danger"
                        >{{$lang.messages.select_city}}</span>
                      </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label>{{$lang.messages.district}}</label>
                      <span style="color:#ff0000">*</span>
                      <div class="text-right custom-select-dd">
                        <select
                          v-model="store.city_id"
                          name="city_id"
                          class="form-control"
                          v-validate="'required'"
                          :class="{'input': true, 'is-danger': errors.has('city_id') }"
                        >
                          <option value>{{$lang.messages.select_district}}</option>
                          <option
                            v-for="city in cityList"
                            :key="city.id"
                            :value="city.id"
                          >{{city.name}}</option>
                        </select>
                        <i v-show="errors.has('city_id')" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('city_id')"
                          class="help is-danger"
                        >{{$lang.messages.select_district}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 px-0">
                  <div class="row mb-4">
                    <div class="col-lg-6 mb-4">
                      <label>{{$lang.messages.postal_or_zip_code}}</label>
                      <input
                        name="postal_code"
                        v-model="store.postal_code"
                        class="form-control"
                        v-validate="'numeric'"
                        :class="{'input': true, 'is-danger': errors.has('postal_code') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.postal_or_zip_code"
                      />
                      <i v-show="errors.has('postal_code')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('postal_code')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_zip_code}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-4 px-0">
                  <label for>{{$lang.messages.description}}</label>
                  <textarea
                    class="form-control"
                    v-model="store.description"
                    v-bind:placeholder="$lang.messages.description"
                    style="height: auto"
                  ></textarea>
                </div>

                <div class="col-md-12 px-0" v-if="is_enable_b2b && (is_owner || access_right.edit_b2b_store)">
                  <div class="row mb-4">
                    <div class="col-lg-9 mb-4">
                      <p class="mb-0">{{$lang.messages.enable_b2b}}</p>
                    </div>
                    <div class="col-lg-3 text-md-right mb-4">
                      <div class="form-group">
                          <span class="switch switch-sm">
                            <input
                                type="checkbox"
                                class="switch"
                                id="switch-12"
                                v-model="store.is_enable_b2b"
                            />
                            <label for="switch-12"></label>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 text-lg-right text-center">
          <button
            type="button"
            class="btn btn-primary mr-3"
            id="save-btn"
            @click="validateForm()"
          >{{$lang.messages.save_btn_text}}</button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="$router.go(-1)"
          >{{$lang.messages.cancel_btn_text}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../../router";
export default {
  name: "AddStore",
  data() {
    return {
      store: {
        address: "",
        phone_number: "",
        description: "",
        mobile_number: "",
        email: "",
        name: "",
        country_id: "",
        state_id: "",
        district_id: "",
        postal_code:"",
        city_id: "",
        id: null,
        is_enable_b2b: true
      },
      country_code: "",
      countryList: [],
      stateList: [],
      districtList: [],
      cityList: [],
      villageList: [],
      is_owner: false,
      access_right: {},
      is_enable_b2b: false,
    };
  },
  methods: {
    details(id) {
      this.store = {};
      this.$api
        .getAPI({
          _action: "/store/detail/" + id
        })
        .then(res => {
          this.store = res;
          if (res.country_id) {
            this.getStateList(res.country_id, false);
          }
          if (res.state_id) {
            this.getDistrictList(res.state_id, false);
          }
          if (res.district_id) {
            this.getCityList(res.district_id, false);
          }
          if (res.city_id) {
            this.getVillageList(res.city_id, false);
          }
        });
    },

    gotoStore() {
      router.push("/settings");
    },
    save() {
      localStorage.setItem('cacheVersion', Date.now())
      this.$api
        .postAPI({
          _action: "/store/",
          _body: this.store,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          this.gotoStore();
        })
        .catch(e => {});
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },
    getCountryList() {
      this.$api
        .getAPI({
          _action: "/country/list"
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.countryList = res.list;
          }
        })
        .catch(e => {});
    },
    getStateList(country_id, flag) {
      if (flag) {
        this.store.state_id = "";
        this.store.district_id = "";
        this.store.city_id = "";
      }
      if (country_id) {
        this.$api
          .getAPI({
            _action: "/state/list/" + country_id
          })
          .then(res => {
            this.stateList = res.list;
          })
          .catch(e => {});
      }
    },
    getDistrictList(state_id, flag) {
      if (flag) {
        this.store.district_id = "";
        this.store.city_id = "";
      }
      if (state_id) {
        this.$api
          .getAPI({
            _action: "/district/list/" + state_id
          })
          .then(res => {
            this.districtList = res.list;
          })
          .catch(e => {});
      }
    },

    getCityList(district_id, flag) {
      if (flag) {
        this.store.city_id = "";
      }
      if (district_id) {
        this.$api
          .getAPI({
            _action: "/city/list/" + district_id
          })
          .then(res => {
            this.cityList = res.list;
          })
          .catch(e => {});
      }
    },

    getVillageList(city_id) {
      if (city_id) {
        this.store.village_id = "";
      }
      if (city_id) {
        this.$api
          .getAPI({
            _action: "/village/list/" + city_id
          })
          .then(res => {
            this.villageList = res.list;
          })
          .catch(e => {});
      }
    },
    getMe() {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          if (res.user.is_owner) {
            this.is_owner = true;
            this.is_enable_b2b = res.setting.is_enable_b2b
          }
          this.access_right = res.access_right;
        });
    },
  },
  mounted() {
    this.getMe();
    this.getCountryList();
    this.country_code = localStorage.getItem("country_code");
    this.store.country_id = localStorage.getItem("country_id");
    this.getStateList(this.store.country_id, false);
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>